// extracted by mini-css-extract-plugin
export default {"container":"IconWithText_container__Ag2Xh"};